export default class BackofficeSatisfactionFormFieldsForm {
  constructor() {
    // Only initialize if the form exists on the page
    if ($('#field_type_select').length > 0) {
      this.bindEvents();
      this.updateVisibleSections();
      this.initializeAutoGenerateKey();
    }
  }

  bindEvents() {
    // Field type change
    $(document).on('change', '#field_type_select', this.updateVisibleSections.bind(this));
    
    // Parent field change
    $(document).on('change', '#parent_field_select', this.toggleParentOptions.bind(this));
    
    // Add option button
    $(document).on('click', '.add-option-btn', this.addOption.bind(this));
    
    // Remove option button
    $(document).on('click', '.remove-option-btn', this.removeOption.bind(this));
  }

  updateVisibleSections() {
    const fieldType = $('#field_type_select').val();
    
    // Hide all sections
    $('#number-fields').addClass('d-none');
    $('#options-fields').addClass('d-none');
    $('#text-fields').addClass('d-none');
    
    // Hide/show required toggle (section_title doesn't support required)
    if (fieldType === 'section_title') {
      $('#is-required-container').addClass('d-none');
      $('#is_required').prop('checked', false);
    } else {
      $('#is-required-container').removeClass('d-none');
    }

    // Show relevant sections based on field type
    if (fieldType === 'number') {
      $('#number-fields').removeClass('d-none');
    }
    if (fieldType === 'select_field' || fieldType === 'radio') {
      $('#options-fields').removeClass('d-none');
      $('textarea[name="satisfaction_form_field[options_list]"]').prop('required', true);
    } else {
      $('textarea[name="satisfaction_form_field[options_list]"]').prop('required', false);
    }
    if (fieldType === 'text' || fieldType === 'textarea' || fieldType === 'number' || fieldType === 'select_field') {
      $('#text-fields').removeClass('d-none');
    }
  }

  toggleParentOptions() {
    const parentFieldId = $('#parent_field_select').val();
    const $showOnContainer = $('#show-on-container');
    
    if (parentFieldId) {
      $showOnContainer.removeClass('d-none');
    } else {
      $showOnContainer.addClass('d-none');
      $('#satisfaction_form_field_show_on_parent_value').val('');
    }
  }

  addOption(event) {
    event.preventDefault();
    const $container = $('.options-container');
    const index = $container.find('.option-row').length;
    
    const $row = $(`
      <div class="option-row d-flex align-items-center mb-2">
        <input type="text" 
               name="satisfaction_form_field[options_list][]" 
               class="form-control form-control-sm mr-2" 
               placeholder="valeur|libellé">
        <button type="button" class="btn btn-sm btn-outline-danger remove-option-btn">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
    `);
    
    $container.append($row);
  }

  removeOption(event) {
    event.preventDefault();
    const $btn = $(event.currentTarget);
    const $row = $btn.closest('.option-row');
    
    // Keep at least one option
    if ($('.options-container .option-row').length > 1) {
      $row.fadeOut(200, function() {
        $(this).remove();
      });
    }
  }

  initializeAutoGenerateKey() {
    const $labelInput = $('[data-generate-key]');
    const $fieldKeyInput = $('[name="satisfaction_form_field[field_key]"]');
    
    if ($labelInput.length && $fieldKeyInput.length && !$fieldKeyInput.val()) {
      $labelInput.on('input', function() {
        const key = $(this).val()
          .toLowerCase()
          .normalize('NFD')
          .replaceAll(/[\u0300-\u036f]/, '')
          .replaceAll(/([^a-z0-9]+)/, '_')
          .replaceAll(/(^_+|_+$)/, '')
          .substring(0, 50);
        $fieldKeyInput.val(key);
      });
    }
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(document).off('change', '#field_type_select');
    $(document).off('change', '#parent_field_select');
    $(document).off('click', '.add-option-btn');
    $(document).off('click', '.remove-option-btn');
    $('[data-generate-key]').off('input');
  }
}